import React, { useState } from 'react';
import { DecorationTab } from "../App";
import { Tabs, Parallax } from "../components";
import { Helmet } from "react-helmet";
import parse from 'html-react-parser';

interface DecorationInterface {
    data?: DecorationTab[],
    scrollText?: string,
    headHtml?: string
}

export default function Gallery(props: DecorationInterface) {

    const returnTabsId = (data?: DecorationTab[]) => {
        if (!data) return;
        return data.map(({name = ""}: DecorationTab) => name);
    }
    
    const setDefaultTab = () => {
        const tabIds = returnTabsId(props.data);
        if (tabIds) {
            if (tabIds[0]) return tabIds[0];
        }
        return '';
    }

    const [activeTab, setActiveTab] = useState(setDefaultTab());
    const [fade, setFade] = useState(false);
    const [showParallax, setShowParallax] = useState(true);

    const returnTabs = (data?: DecorationTab[]) => {
        if (!data) return;
        const activeTabData: DecorationTab[] = data.filter(({ name = "" }: DecorationTab) => activeTab === name);
        if (!activeTabData.length) return;
        return showParallax ? <Parallax
            type="decoration"
            elements={activeTabData[0].photos} 
            name={activeTabData[0].name} 
            text={activeTabData[0].text} 
        /> : null;
    }

    const changeTab = (id: string) => {
        setFade(true);
        setTimeout(() => {
            setShowParallax(false);
            setTimeout(() => {
                setActiveTab(id);
                setShowParallax(true);
                setFade(false);
            });
        }, 410);
    }

    const returnHead = (headData?: string) => {
        if (!headData) return;
        try {
            const html = parse(headData);
            return html;
        } catch(err) {}
    }
    
    return (
        <div className="decoration_pop">
            <Helmet>{returnHead(props.headHtml)}</Helmet>
            <Tabs ids={returnTabsId(props.data || [])} active={activeTab} changeTab={(id: string) => changeTab(id)} scrollText={props.scrollText} />
            <div className={"tabs_holder" + (fade ? " fade" : "")}>{returnTabs(props.data)}</div>
        </div>
    )
}
